<template>
    <div class="tooltip">
        <slot></slot>
        <span
            class="tooltiptext"
            v-html="text"
        />
    </div>
</template>
<script>
import {url} from "../../../../helpers";

export default {
    props: {
        text: {
            type: String
        }
    },
    methods: {
        url,
    },
}
</script>
<style lang="scss">
.tooltip {
    position: relative;
    display: inline-block;
    cursor: pointer;

    img {
        max-height: 13px;
        margin: 0 0 -1px;
    }

    &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
    }

    .tooltiptext {
        top: auto;
        right: auto;
        bottom: 115%;
        left: 50%;
        position: absolute;
        visibility: hidden;
        width: 120px;
        background-color: #555;
        padding: 5px 3px;
        border-radius: 6px;
        z-index: 1;
        margin-left: -60px;
        opacity: 0;
        -webkit-transition: opacity 0.3s;
        -moz-transition: opacity 0.3s;
        -ms-transition: opacity 0.3s;
        -o-transition: opacity 0.3s;
        transition: opacity 0.3s;
        font-size: 14px;
        line-height: 1.4;
        color: #fff;
        text-align: center;

        &:after {
            content: "";
            top: 100%;
            right: auto;
            bottom: auto;
            left: 50%;
            position: absolute;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #555 transparent transparent transparent;
        }

        &.bottom {
            bottom: auto;
            top: 125%;

            &:after {
                top: auto;
                bottom: 100%;
                -webkit-transform: rotate(180deg);
                -moz-transform: rotate(180deg);
                -ms-transform: rotate(180deg);
                transform: rotate(180deg);
            }
        }
    }
}
</style>
